<mat-dialog-content style="height: 73vh;">
    <div style="margin-bottom: 2%;">
        <strong >{{titulo}}</strong>
    </div>
    <div [hidden]="nombreTipoDomicilio!=''" style="width: 40%;">
      <mat-form-field style="width: 80%; font-size: 2.0vh;">
        <input matInput placeholder="Tipo de domicilio"
            [(ngModel)]=txtTipoDomicilio autocomplete="off"
            (keydown.enter)="buscarTipoDomicilio()">
      </mat-form-field>
      <i class="fas fa-search" style="font-size: 1.5em; cursor: pointer; color: #4b8cc5;
          margin-top: 0px;" (click)="buscarTipoDomicilio()"
          matTooltip="Buscar tipo de domicilio">
      </i>
    </div>
    <div [hidden]="nombreTipoDomicilio==''" style="text-align: start; margin-right: 5px;
      margin-top: 50px;">
      <i class="fas fa-trash" style=" margin-right: 5px;
          font-size: 1.5em; cursor: pointer; color: #4b8cc5;
          margin-top: 0px;" (click)="eliminarTipoDomicilio()"
          matTooltip="Eliminar tipo de domicilio">
      </i>
      <mat-label>{{nombreTipoDomicilio}}</mat-label>
    </div>
    <table style="width: 100%; margin-bottom: 10px; margin-top: 10px;">
      <tr>
        <td style="width: 20%;">
          <mat-form-field style="width: 100%; font-size: 2.0vh;">
            <input matInput placeholder="Calle"
                [(ngModel)]=txtDomicilioCalle autocomplete="off">
          </mat-form-field>
        </td>
        <td style="width: 2.5%;"></td>
        <td style="width: 5%;">
          <mat-form-field style="width: 100%; font-size: 2.0vh;">
            <input matInput placeholder="Num."
                [(ngModel)]=txtDomicilioNum autocomplete="off">
          </mat-form-field>
        </td>
        <td style="width: 2.5%;"></td>
        <td style="width: 5%;">
          <mat-form-field style="width: 100%; font-size: 2.0vh;">
            <input matInput placeholder="Piso"
                [(ngModel)]=txtDomicilioPiso autocomplete="off">
          </mat-form-field>
        </td>
        <td style="width: 2.5%;"></td>
        <td style="width: 5%;">
          <mat-form-field style="width: 100%; font-size: 2.0vh;">
            <input matInput placeholder="Dpto"
                [(ngModel)]=txtDomicilioDepto autocomplete="off">
          </mat-form-field>
        </td>
        
      </tr>
    </table>
    <div [hidden]="nombreProvincia!=''" style="width: 40%;">
      <mat-form-field style="width: 80%; font-size: 2.0vh;">
        <input matInput placeholder="Provincia"
            [(ngModel)]=txtProvincia autocomplete="off"
            (keydown.enter)="buscarProvincia()">
      </mat-form-field>
      <i class="fas fa-search" style="font-size: 1.5em; cursor: pointer; color: #4b8cc5;
          margin-top: 0px;" (click)="buscarProvincia()"
          matTooltip="Buscar provincia">
      </i>
    </div>
    <div [hidden]="nombreProvincia==''" style="text-align: start; margin-right: 5px;
      margin-top: 30px;">
      <i class="fas fa-trash" style=" margin-right: 5px;
          font-size: 1.5em; cursor: pointer; color: #4b8cc5;
          margin-top: 0px;" (click)="eliminarProvincia()"
          matTooltip="Eliminar la provincia">
      </i>
      <mat-label>{{nombreProvincia}}</mat-label>
    </div>
    <div [hidden]="nombreLocalidad!=''" style="width: 40%; margin-top: 10px;">
      <mat-form-field style="width: 80%; font-size: 2.0vh;">
        <input matInput placeholder="Localidad"
            [(ngModel)]=txtLocalidad autocomplete="off"
            (keydown.enter)="buscarLocalidad()">
      </mat-form-field>
      <i class="fas fa-search" style="font-size: 1.5em; cursor: pointer; color: #4b8cc5;
          margin-top: 0px;" (click)="buscarLocalidad()"
          matTooltip="Buscar localidad">
      </i>
    </div>
    <div [hidden]="nombreLocalidad==''" style="text-align: start; margin-right: 5px;
      margin-top: 30px;">
      <i class="fas fa-trash" style=" margin-right: 5px;
          font-size: 1.5em; cursor: pointer; color: #4b8cc5;
          margin-top: 0px;" (click)="eliminarLocalidad()"
          matTooltip="Eliminar la localidad">
      </i>
      <mat-label>{{nombreLocalidad}}</mat-label>
    </div>
</mat-dialog-content>
<div style="text-align: center;">
    <table style="width: 100%; text-align: center;">
        <tr>
            <td style="width: 30%;">
                <button mat-raised-button class="btn-agregar" (click)="cerrar('cancela')">
                    <i class="fas fa-arrow-circle-left fa-1x" style="width: 20px; margin-right:10px;
                                    font-size: 1.5em; cursor: pointer;"></i>
                    Cancelar
                </button>
            </td>
            <td style="width: 20%;"></td>
            <td style="width: 30%;">
                <button mat-raised-button class="btn-agregar" (click)="almacenar()" style="margin-left: 30px;">
                    <i class="fas fa-save fa-1x" style="width: 20px; margin-right:10px;
                                    font-size: 1.5em; cursor: pointer;"></i>
                    Almacenar
                </button>
            </td>
        </tr>
    </table>
</div>
